export const GET_EMAILS_AS_TEST_ACCOUNTS = 'GET_EMAILS_AS_TEST_ACCOUNTS';
export const GET_EMAILS_AS_TEST_ACCOUNTS_REQUEST = 'GET_EMAILS_AS_TEST_ACCOUNTS_REQUEST';
